module.exports = __webpack_public_path__ + "img/ep-S-dosis.f2d4326f.jpg";